import type { FeaturesTranslations } from '../../types';

export const frFeatures: FeaturesTranslations = {
  tech: {
    title: '\u00C9l\u00E9ment chauffant innovant',
    description: 'Les radiateurs JH \u00E9mettent des rayons infrarouges lointains qui r\u00E9chauffent directement les personnes et les objets \u2014 tout comme la chaleur naturelle du soleil. Cela procure une chaleur rapide, uniforme et silencieuse, sans bruit, sans vent, sans lumi\u00E8re et sans poussi\u00E8re, tout en consommant nettement moins d\'\u00E9nergie que les radiateurs conventionnels.',
    aluminum: 'Alliage d\'aluminium sp\u00E9cial \u00E0 ailettes',
    nano: 'Rev\u00EAtement NANO sp\u00E9cial pour l\'\u00E9mission infrarouge lointaine',
    insulation: '86 % d\'efficacit\u00E9 d\'\u00E9mission de rayons infrarouges lointains',
    lifespan: 'Stockage thermique r\u00E9fl\u00E9chissant brevet\u00E9 (+20 % d\'\u00E9conomies d\'\u00E9nergie)',
  },
};
